/**
 * Convert UTC date to MM/DD/YY
 */
export const utcToSlashDate = (utcDate: string) => {
  const date = new Date(utcDate)
  const month = `0${date.getMonth() + 1}`.slice(-2)
  const day = `0${date.getDate() + 1}`.slice(-2)
  return `${month}/${day}/${date.getFullYear()}`
}
